import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
// -
import ButtonsActions from "../../utils/buttonsActions";
import TopBarActions from "components/TopBarActionsFree";
import TabListRouteTable from "./TabListRouteTable";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import axiApi from "ApiCaller";

const TabListRoutes = () => {
    const {t: _Tr} = useTranslation("routes");
    const navigate = useNavigate();
    const buttonsTool = useRef(new ButtonsActions());
    const [buttonsTB, setButtonsTB] = useState(buttonsTool.current);
    const [itemsShown, setItemsShown] = useState([]);
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        buttonsTool.current.title = _Tr("labels.routes");

        buttonsTool.current.edit.active = true;
        buttonsTool.current.edit.disabled = true;
        buttonsTool.current.edit.onClick = onClickEdit;
        setButtonsTB({...buttonsTool.current});
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchData();
        };
        filters.current.filter = () => {
            fetchData();
        };
        const fetchGetData = () => {
            setIsLoading(true);
            axiApi
                .get("/api/distribution/routes/")
                .then((res) => {
                    items.current.all = [...res.data.items];
                    items.current.shown = [...res.data.items];
                    setItemsShown([...res.data.items]);
                    if (res.data.pager) {
                        pagerModelRef.current.paging.update(res.data.pager);
                    }
                })
                .finally(() => {
                    setIsLoading(false);
                });
        };
        fetchGetData();
    }, []);

    const onClickEdit = () => {
        if (items.current.chosen.length > 1 || items.current.chosen.length === 0) {
            return false;
        }
        let idx = parseInt(items.current.chosen[0]);
        let route = {...items.current.shown[idx]};
        navigate(`/route-management/route/${route.id}/`);
    };
    const fetchData = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/routes/", filters.current.chosen, {
                params: pagerModelRef.current.paging.getParams(),
            })
            .then((res) => {
                items.current.all = [...res.data.items];
                items.current.shown = [...res.data.items];
                setItemsShown([...res.data.items]);
                if (res.data.pager) {
                    pagerModelRef.current.paging.update(res.data.pager);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <TopBarActions actions={buttonsTB} filtersRef={filters} className="sticky-top" style={{top: "72px"}} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" />
            <div className="col-12">
                <LoaderSpinner isLoading={isLoading}>
                    <TabListRouteTable
                        items={items}
                        itemsShown={itemsShown}
                        setItemsShown={setItemsShown}
                        setButtonsTB={setButtonsTB}
                        buttonsTB={buttonsTB}
                    />
                </LoaderSpinner>
            </div>
        </>
    );
};
export default TabListRoutes;
